import { ReactGoogleChartProps } from 'react-google-charts'

export const defaultColumnChart = {
    chartType: 'ColumnChart',
    options: {
        legend: { position: 'top' },
        isStacked: true,
        bar: { width: '50' },
        chartArea: { left: 70, top: 70, right: 40, bottom: 70 },
        hAxis: { slantedText: true },
        height: 500,
    },
} as ReactGoogleChartProps

export const defaultStackedColumnChart = {
    ...defaultColumnChart,
    options: {
        ...defaultColumnChart.options,
        isStacked: true,
    },
}
